import * as React from 'react';
import moment from 'moment';

import CalendarText from '../../contexts/calendar-text';
import LazyImage from '../lazy-image';
import { isExternalUrl } from '../../helpers/is-external-url';

import ListEventTagsView from './event-tags.view';
import { IEvent } from '../../interfaces';

export interface IListEventViewProps {
    event: IEvent;
    allowTabbing: boolean;
}

/**
 * The view for an individual calendar event.
 */
class ListEventView extends React.PureComponent<IListEventViewProps> {
    render(): React.ReactNode {
        const eventMoment = moment(this.props.event.eventDate);
        //const ctaButton = () => {

        //}

       return (
            <CalendarText.Consumer>
                {text => (
                    <li className="ace-date-row">
                        {this.eventDetails()}
                    </li>
                )}
            </CalendarText.Consumer>
        );
    }

    eventDetails() {
        const eventIsOnSale = this.props.event.buyTicketDisabled === false && ((this.props.event.currentMosOnSaleDate
            && this.props.event.currentMosOnSaleDate < new Date()
            && this.props.event.currentMosOnSaleEndDate > new Date()
            && this.props.event.soldOut === false)
            || this.props.event.onSale === true);
            

        const isVolunteer = this.props.event.volunteerPurchase;
        
        if (this.props.event.hideAvailability) {
            this.props.event.availabilityOverrideText = "";
        }

        const dateX = moment(this.props.event.eventDate).startOf('day').format("X");

        return (
            <>
                <div className="ace-date-row-info" id={`List-Day-${dateX}`}>
                    <p className="bold">{this.props.event.eventDateString}</p>
                    <p className="light-weight">{this.props.event.eventTimeString}</p>
                    <p>{this.props.event.performanceNote}</p>
                  
                </div>
                <div className="ace-date-row-supplementary">
                    {
                        eventIsOnSale ?
                            <a href={this.props.event.buyTicketCtaUrl} className={!this.props.event.buyTicketDisabled ? "btn" : "btn disabled"} target={isExternalUrl(this.props.event.buyTicketCtaUrl) ? "_blank" : null} tabIndex={this.props.allowTabbing ? 0 : -1}>
                                {
                                    isVolunteer ? this.props.event.volunteerbuyTicketCtaText : this.props.event.buyTicketCtaText
                                }
                            </a>
                            :
                            <button className={!this.props.event.buyTicketDisabled ? "btn" : "btn disabled"} disabled tabIndex={this.props.allowTabbing ? 0 : -1}>
                                {this.props.event.buyTicketCtaText}
                            </button>
                    }
                </div>
            </>
        );
    }
}

export default ListEventView;
